export class SubscriptionPlan {
    id: number;
    name: string;
    maxMachines: number | null; // null = unlimited
    maxUsers: number | null;
    tasksEnabled: boolean;
    defectsEnabled: boolean;

    constructor(
        id: number,
        name: string,
        maxMachines: number | null,
        maxUsers: number | null,
        tasksEnabled: boolean,
        defectsEnabled: boolean
    ) {
        this.id = id;
        this.name = name;
        this.maxMachines = maxMachines;
        this.maxUsers = maxUsers;
        this.tasksEnabled = tasksEnabled;
        this.defectsEnabled = defectsEnabled;
    }

    // also the form template: gives the input type of fields that come back null
    static empty(): SubscriptionPlan {
        return { id: 0, name: '', maxMachines: NaN, maxUsers: NaN, tasksEnabled: false, defectsEnabled: false };
    }
}

export type CurrentSubscription = {
    subscriptionPlan: SubscriptionPlan;
    machineCount: number;
    userCount: number;
}
